import React from "react";
import PopOver from "../components/Popover";
import ClassDrawerPopOver from "./ClassDrawerPopOver";
import ClassPopOver from "./ClassPopOver";
import CommunicationPopOver from "./CommunicationPopOver";
import DepositsPopover from "./DepositsPopover";
import FinancePopover from "./FinancePopover";
import ParticipantPopOver from "./ParticipantPopOver";
import PenddingPopover from "./PenddingPopover";
import ReportPopover from "./ReportPopover";
import UserPopover from "./UserPopover";

const Action = ({
  action,
  drawerBol,
  reversalCheck,
  handleBatchId,
  templateVal = false,
  onUpdatePaymentClick,
  OnRecurringAction,
  onCreateCampaignClick,
  setReceiptFile,
  setInvoiceFile,
  setReceiptDownload,
  setInvoiceDownload,
  onEditClick,
  onViewClick,
  onDeleteClick,
  onMergeClick,
  onCancelClick,
  checkActive,
  onActiveClick,
  style,
  id,
  status,
  page,
  handleClick,
  onEditNowClick,
  generateExcel,
  row,
  onEdit,
  Unbatch,
  Undeposit,
  generatePdf,
  check,
  markAsSynced,
  markAsBatchedSynced,
  actionDrawer,
  rowId,
  onChargeEditClick,
  deleteFilter,
  item,
  setDuolicatetModal,
  setDuolicatetData,
  generateExcelReport,
  onDuplicateClick,
  onUpgradeClick,
  onArchiveClick,
  onClassDeleteClick,
  handleDownloadPdf,
  setExpandRow,
  setOpen,
  setShareInvoicePDF,
  setShareReceiptPDF,
  handleRunReport,
  toggle,
  onSharePymentClick,
  onPayClick,
  onUpdateClick,
  chargeStatus,
  setUpdateUserRow,
  setIsUpdateUserDrawerOpen,
  setRefresh,
  refresh,
  setOpenAlertDelete,
  setDeleteHandle,
  deleteHandle,
  setOpenAlertBlock,
  setblockHandle,
  blockHandle,
  setUserId,
  userId,
  setBlockedRow,
  MoreVert,
  activeUesr,
  generateDepositeExcel,
  shareDepositePdf,
  shareLoading,
  onSendPaymentLinkClick,
  onParticipantDeleteClick,
  onMoveToClick,
  setClassMovedId,
  setConfirmDialog,
  checkData,
  onEditNoteClick,
  hideInvoiceButtons,
  hideReceiptButtons,
  onRegistrationLinkClick,
  onInviteClick,
  popOverWidth,
  inviteText,
  disableSharePaymentLink,
  onAddMournerClick,
  onCancelPaymentClick,
  onPauseStart,
  pauseOrStart,
  isEditHide,
  disableDeleteButton,
  disableActionButton,
  onAddClick,
  onSendLetterClick,
  sentInvitation,
  ...rest
}) => {
  return (
    <>
      {!action ? (
        <PopOver
          templateVal={templateVal}
          style={style}
          onEditClick={onEditClick}
          onDeleteClick={onDeleteClick}
          onMergeClick={onMergeClick}
          checkActive={checkActive}
          onActiveClick={onActiveClick}
          onViewClick={onViewClick}
          onEditNoteClick={onEditNoteClick}
          onInviteClick={onInviteClick}
          popOverWidth={popOverWidth}
          inviteText={inviteText}
          onAddMournerClick={onAddMournerClick}
          {...rest}
        />
      ) : action === "finance" ? (
        <FinancePopover
          style={style}
          {...rest}
          action={action}
          drawerBol={drawerBol}
          row={row}
          reversalCheck={reversalCheck}
          setReceiptFile={setReceiptFile}
          onUpdatePaymentClick={onUpdatePaymentClick}
          OnRecurringAction={OnRecurringAction}
          setShareInvoicePDF={setShareInvoicePDF}
          setShareReceiptPDF={setShareReceiptPDF}
          onChargeEditClick={onChargeEditClick}
          setReceiptDownload={setReceiptDownload}
          setInvoiceDownload={setInvoiceDownload}
          setInvoiceFile={setInvoiceFile}
          actionDrawer={actionDrawer}
          rowId={rowId}
          onSharePymentClick={onSharePymentClick}
          onPayClick={onPayClick}
          onUpdateClick={onUpdateClick}
          onDeleteClick={onDeleteClick}
          onCancelClick={onCancelClick}
          onCancelPaymentClick={onCancelPaymentClick}
          setExpandRow={setExpandRow}
          chargeStatus={chargeStatus}
          checkData={checkData}
          hideInvoiceButtons={hideInvoiceButtons}
          hideReceiptButtons={hideReceiptButtons}
          disableSharePaymentLink={disableSharePaymentLink}
          disableDeleteButton={disableDeleteButton}
          isEditHide={isEditHide}
          disableActionButton={disableActionButton}
        />
      ) : action === "tribute" ? (
        <FinancePopover
          style={style}
          {...rest}
          action={action}
          row={row}
          onEditNowClick={onEditClick}
          onViewClick={onViewClick}
          onAddClick={onAddClick}
          onSendLetterClick={onSendLetterClick}
        />
      ) : action === "BatchBilling" ? (
        <FinancePopover
          style={style}
          {...rest}
          action={action}
          id={id}
          status={status}
          page={page}
          setOpen={setOpen}
          handleBatchId={handleBatchId}
          handleClick={handleClick}
          onEditNowClick={onEditNowClick}
        />
      ) : action === "pending" ? (
        <PenddingPopover
          generateExcel={generateExcel}
          Unbatch={Unbatch}
          markAsBatchedSynced={markAsBatchedSynced}
          check={check}
        />
      ) : action === "deposits" ? (
        <DepositsPopover
          Undeposit={Undeposit}
          generatePdf={generatePdf}
          check={check}
          markAsSynced={markAsSynced}
          generateDepositeExcel={generateDepositeExcel}
          shareDepositePdf={shareDepositePdf}
          shareLoading={shareLoading}
          row={row}
        />
      ) : action === "report" ? (
        <ReportPopover
          Undeposit={Undeposit}
          generatePdf={generatePdf}
          handleRunReport={handleRunReport}
          check={check}
          deleteFilter={deleteFilter}
          item={item}
          setDuolicatetModal={setDuolicatetModal}
          setDuolicatetData={setDuolicatetData}
          generateExcelReport={generateExcelReport}
          handleDownloadPdf={handleDownloadPdf}
          toggle={toggle}
        />
      ) : action === "userAction" ? (
        <UserPopover
          setUpdateUserRow={setUpdateUserRow}
          setIsUpdateUserDrawerOpen={setIsUpdateUserDrawerOpen}
          row={row}
          setRefresh={setRefresh}
          refresh={refresh}
          setOpenAlertDelete={setOpenAlertDelete}
          setDeleteHandle={setDeleteHandle}
          deleteHandle={deleteHandle}
          setOpenAlertBlock={setOpenAlertBlock}
          setblockHandle={setblockHandle}
          blockHandle={blockHandle}
          setUserId={setUserId}
          userId={userId}
          setBlockedRow={setBlockedRow}
          MoreVert={MoreVert}
          activeUesr={activeUesr}
        />
      ) : action === "class" || action === "event" || action === "form" ? (
        <ClassPopOver
          style={style}
          onViewClick={onViewClick}
          onEditClick={onEditClick}
          onDuplicateClick={onDuplicateClick}
          onUpgradeClick={onUpgradeClick}
          onArchiveClick={onArchiveClick}
          onActiveClick={onActiveClick}
          onClassDeleteClick={onClassDeleteClick}
          onRegistrationLinkClick={onRegistrationLinkClick}
          action={action}
          sentInvitation={sentInvitation}
          {...rest}
        />
      ) : action === "communication" ? (
        <CommunicationPopOver
          style={style}
          onViewClick={onViewClick}
          onEditClick={onEditClick}
          onDuplicateClick={onDuplicateClick}
          onDeleteClick={onDeleteClick}
          onCreateCampaignClick={onCreateCampaignClick}
          onPauseStart={onPauseStart}
          pauseOrStart={pauseOrStart}
          action={action}
          isEditHide={isEditHide}
          {...rest}
        />
      ) : action === "classDrawer" ||
        action === "eventDrawer" ||
        action === "formDrawer" ? (
        <ClassDrawerPopOver
          style={style}
          onEditClick={onEditClick}
          onArchiveClick={onArchiveClick}
          onClassDeleteClick={onClassDeleteClick}
          action={action}
          styles={style}
          {...rest}
        />
      ) : action === "participant" ? (
        <ParticipantPopOver
          style={style}
          onViewClick={onViewClick}
          onSendPaymentLinkClick={onSendPaymentLinkClick}
          onEditClick={onEditClick}
          onParticipantDeleteClick={onParticipantDeleteClick}
          onMoveToClick={onMoveToClick}
          setClassMovedId={setClassMovedId}
          setConfirmDialog={setConfirmDialog}
          sentInvitation={sentInvitation}
          {...rest}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default Action;
